module.exports = __webpack_public_path__ + "img/main-list_07.52dbc038.jpg";